import type { ReactNode } from 'react';
import { Stack, Typography } from '@mui/material';
import { BankSlipPaymentDetails } from './bank-slip';
import { PixPaymentDetails } from './pix';
import payment from '@/assets/images/svg/payment.svg';
import { ContentBox } from '@/components/shared/content-box';
import { PaymentMethod as PaymentMethodEnum } from '@/data/catalog/offer/interfaces';
import { paymentMethodLabel } from '@/packages/courses/pages/checkout/constants/payment-methods';
import { useCheckoutWizard } from '@/packages/courses/pages/checkout/hooks/useCheckoutWizard';
import { CheckoutStepIds } from '@/packages/courses/pages/checkout/types';
import { formatMoney } from '@/utils/format-money';

export const PixBankSlipStep = () => {
  const { values, offer } = useCheckoutWizard();

  const paymentMethod = values?.[CheckoutStepIds.PaymentMethod]?.paymentMethod;
  const totalAmount = offer?.checkout_pricing?.calculated_amount;

  const content: Partial<Record<PaymentMethodEnum, ReactNode>> = {
    [PaymentMethodEnum.Pix]: <PixPaymentDetails />,
    [PaymentMethodEnum.BankSlip]: <BankSlipPaymentDetails />,
  };

  if (!paymentMethod || !content[paymentMethod]) return null;

  return (
    <Stack spacing={3}>
      <ContentBox spacing={2} justifyContent="center" alignItems="center">
        <img src={payment} alt="Pagamento" width={56} height={56} />
        <Typography textAlign="center">Falta pouco!</Typography>
        <Typography textAlign="center" variant="h2">
          Pague {formatMoney(totalAmount ?? 0)} via{' '}
          {paymentMethodLabel[paymentMethod]} para concluir sua compra.
        </Typography>
      </ContentBox>
      {content[paymentMethod]}
    </Stack>
  );
};
